import { SDK_QpFile } from "../gql/generated/operations";
import { isAcceptedAudioFile, isAcceptedDataFile, isAcceptedImage, UploadFileType } from "./types";

export function getFileType(type: string): UploadFileType {
    if (isAcceptedImage(type)) return "image"
    if (isAcceptedDataFile(type)) return "data"
    if (isAcceptedAudioFile(type)) return "audio"
    return "error"
}

export function getFilesByType(type: UploadFileType, files: SDK_QpFile[]): SDK_QpFile[] {

    return files.filter(file => getFileType(file.fileType) === type)
}


